import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { ActionTypes } from '../../constants/ActionTypes';
import { fetchError } from '../actions/Common';
import { fetchLetterLetterNoteSuccess } from '../actions';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';
import { IGetLetterNoteParams } from '../../interfaces';

const getLetterNote = async (parameters: IGetLetterNoteParams) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `letter/getLetterNote?letterCode=${parameters.letterCode}&pageIndex=${parameters.pageIndex}&pageSize=100`,
  );
};

const addLetterNote = async (parameters: any) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('letter/AddLetterNote', parameters);
};

function* fetchLetterNoteRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedLetterNote = yield call(getLetterNote, action.payload);
    yield put(fetchLetterLetterNoteSuccess(fetchedLetterNote.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchLetterNote() {
  yield takeEvery(ActionTypes.GET_LETTER_NOTE, fetchLetterNoteRequest);
}

function* onAddLetterNoteRequest(action: any) {
  try {
    yield call(addLetterNote, action.payload);
  } catch (error) {
    return ShowError('', error);
  }
}

export function* addLetterNoteRequest() {
  yield takeEvery(ActionTypes.ADD_LETTER_NOTE, onAddLetterNoteRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchLetterNote), fork(addLetterNoteRequest)]);
}
